import { useMutation, useQueryClient } from '@tanstack/react-query'

import { putRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

const updateLicenses = (licenseNumber: string) =>
  putRequest(`/users/licenses/loan-officers?license_number=${licenseNumber}`)

export const useUpdateLicenses = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateLicenses,
    onSuccess: () => {
      queryClient.invalidateQueries(queries.users.me._ctx.licenses)
    },
  })
}
